import { render, staticRenderFns } from "./GiftPaySystemSelect.vue?vue&type=template&id=05628b66&scoped=true&"
import script from "./GiftPaySystemSelect.vue?vue&type=script&lang=js&"
export * from "./GiftPaySystemSelect.vue?vue&type=script&lang=js&"
import style0 from "./GiftPaySystemSelect.vue?vue&type=style&index=0&id=05628b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05628b66",
  null
  
)

export default component.exports